<script>
export default {
  props: {
    value: {
      default: undefined,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    helper: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      default: undefined,
    },
  },
  computed: {
    empty() {
      return !this.length;
    },
    length() {
      return this.value ? this.value.length : 0;
    },
    messages() {
      const list = [];
      if (this.error && this.error.length && Array.isArray(this.error)) {
        this.error.map((message) => list.push(message));
      } else if (typeof this.error === 'string') {
        list.push(`${this.error}`);
      } else if (this.helper) {
        list.push(`${this.helper}`);
      }

      if (this.error && this.required && this.length === 0) {
        list.unshift(`* ${this.label} необходимо заполнить`);
      }

      return list.join('\n\r');
    },
  },
  methods: {
    update(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<template lang="pug">
label(:class="[$style.field, disabled && $style.disabled, empty && $style.empty, icon && $style.iconLeft, !!error && $style.error]")
  ui-input-string(
    :value="value",
    @input="update($event)",
    :class="$style.input",
    :disabled="disabled",
    :maxlength="maxlength",
    ref="input",
    :name="name",
    :password="type === 'password'",
    :error="!!error",
    :required="required")
  ui-icon(:class="$style.icon", v-if="icon") {{ icon }}
  span(:class="$style.label") {{ label }}{{ required ? ` *` : `` }}
  span(:class="$style.footer")
    span(:class="$style.helper") {{ messages }}
    span(:class="$style.maxlength", v-if="maxlength") {{ length }} / {{ maxlength }}
</template>

<style module lang="sass">
.label
  order: 1
  z-index: 2

.input
  order: 2
  z-index: 1

.footer
  order: 3
  z-index: 2

.field
  display: flex
  padding-top: 24px
  position: relative
  flex-direction: column
  z-index: auto

.icon
  width: 24px
  height: 24px
  margin-top: 4px
  margin-bottom: -28px
  color: $s_inp_border
  .input:focus ~ &, .field:not(.empty) &
    color: $s_color_main

  .error &
    color: $s_inp_error_color !important

  .disabled &
    color: $s_inp_text_disabled !important

.iconLeft
  .input, .label, .footer
    margin-left: 32px

.label
  position: absolute
  display: block
  box-sizing: content-box
  font-size: $s_inp_font
  font-weight: $s_inp_font_weight
  line-height: 24px
  height: 24px
  top: 28px
  left: 0
  pointer-events: none
  color: $s_inp_label_color
  user-select: none
  transition: top $a_speed, font-size $a_speed, color $a_speed
  .input:focus ~ &, .field:not(.empty) &
    top: 8px
    font-size: 12px
    color: $s_color_main

  .error &
    color: $s_inp_error_color !important

  .disabled &
    color: $s_inp_text_disabled !important

.input
  height: 32px

.footer
  display: flex
  padding: 8px 0 0
  align-items: strech
  justify-content: space-between
  color: $s_inp_helper_color
  .error &
    color: $s_inp_error_color

.helper
  margin-top: -4px
  font-size: 12px
  line-height: 16px
  overflow: hidden
  text-overflow: ellipsis
  padding-bottom: 4px
  white-space: pre-line

.maxlength
  user-select: none
  margin-top: -4px
  font-size: 12px
  line-height: 16px
  padding-left: 8px
  padding-bottom: 4px
  text-align: right
  white-space: nowrap

</style>
